export enum ChestEvalGenStareSanFieldNames{
    BUL_INFO_SB_V1__info1_1 = "BUL_INFO_SB_V1__info1_1",
    BUL_INFO_SB_V1__info1_2 = "BUL_INFO_SB_V1__info1_2",
    BUL_INFO_SB_V1__info1_2extra = "BUL_INFO_SB_V1__info1_2extra",

    BUL_INFO_SB_V1__info2_1 = "BUL_INFO_SB_V1__info2_1",
    BUL_INFO_SB_V1__info2_1extra = "BUL_INFO_SB_V1__info2_1extra",

    BUL_INFO_SB_V1__info3_1 = "BUL_INFO_SB_V1__info3_1",
    BUL_INFO_SB_V1__info3_2 = "BUL_INFO_SB_V1__info3_2",
    BUL_INFO_SB_V1__info3_3 = "BUL_INFO_SB_V1__info3_3",
    BUL_INFO_SB_V1__info3_4 = "BUL_INFO_SB_V1__info3_4",
    BUL_INFO_SB_V1__info3_5 = "BUL_INFO_SB_V1__info3_5",
    BUL_INFO_SB_V1__info3_6 = "BUL_INFO_SB_V1__info3_6",
    BUL_INFO_SB_V1__info3_7 = "BUL_INFO_SB_V1__info3_7",

    BUL_INFO_SB_V1__info4_1 = "BUL_INFO_SB_V1__info4_1",
    BUL_INFO_SB_V1__info4_1extra = "BUL_INFO_SB_V1__info4_1extra",

    BUL_INFO_SB_V1__info5_1 = "BUL_INFO_SB_V1__info5_1",
    BUL_INFO_SB_V1__info5_1extra = "BUL_INFO_SB_V1__info5_1extra",

    BUL_INFO_SB_V1__info6_1 = "BUL_INFO_SB_V1__info6_1",

    BUL_INFO_SB_V1__info7_1 = "BUL_INFO_SB_V1__info7_1",
    BUL_INFO_SB_V1__info7_1extra = "BUL_INFO_SB_V1__info7_1extra",

    BUL_INFO_SB_V1__info8_1 = "BUL_INFO_SB_V1__info8_1",

    BUL_INFO_SB_V1__info9_1 = "BUL_INFO_SB_V1__info9_1",
    BUL_INFO_SB_V1__info9_2 = "BUL_INFO_SB_V1__info9_2",
    BUL_INFO_SB_V1__info9_3 = "BUL_INFO_SB_V1__info9_3",
    BUL_INFO_SB_V1__info9_4 = "BUL_INFO_SB_V1__info9_4",

    BUL_INFO_SB_V1__info10_1 = "BUL_INFO_SB_V1__info10_1",

    BUL_INFO_SB_V1__info11_1 = "BUL_INFO_SB_V1__info11_1",
    BUL_INFO_SB_V1__info11_2 = "BUL_INFO_SB_V1__info11_2",
    BUL_INFO_SB_V1__info11_3 = "BUL_INFO_SB_V1__info11_3",
    BUL_INFO_SB_V1__info11_4 = "BUL_INFO_SB_V1__info11_4",
    BUL_INFO_SB_V1__info11_4extra = "BUL_INFO_SB_V1__info11_4extra",
    BUL_INFO_SB_V1__info11_5 = "BUL_INFO_SB_V1__info11_5",
    BUL_INFO_SB_V1__info11_6 = "BUL_INFO_SB_V1__info11_6",
    BUL_INFO_SB_V1__info11_7 = "BUL_INFO_SB_V1__info11_7",
    BUL_INFO_SB_V1__info11_8 = "BUL_INFO_SB_V1__info11_8",
    BUL_INFO_SB_V1__info11_9 = "BUL_INFO_SB_V1__info11_9",
    BUL_INFO_SB_V1__info11_10 = "BUL_INFO_SB_V1__info11_10",
    BUL_INFO_SB_V1__info11_11 = "BUL_INFO_SB_V1__info11_11",
    BUL_INFO_SB_V1__info11_12 = "BUL_INFO_SB_V1__info11_12",

    BUL_INFO_SB_V1__info12_1 = "BUL_INFO_SB_V1__info12_1",
    BUL_INFO_SB_V1__info12_2 = "BUL_INFO_SB_V1__info12_2",
    BUL_INFO_SB_V1__info12_3 = "BUL_INFO_SB_V1__info12_3",
    BUL_INFO_SB_V1__info12_4 = "BUL_INFO_SB_V1__info12_4",
    BUL_INFO_SB_V1__info12_5 = "BUL_INFO_SB_V1__info12_5",

    BUL_INFO_SB_V1__info13_1 = "BUL_INFO_SB_V1__info13_1",
    BUL_INFO_SB_V1__info13_2 = "BUL_INFO_SB_V1__info13_2",
    BUL_INFO_SB_V1__info13_3 = "BUL_INFO_SB_V1__info13_3",
    BUL_INFO_SB_V1__info13_4 = "BUL_INFO_SB_V1__info13_4",

    BUL_INFO_SB_V1__info14_1 = "BUL_INFO_SB_V1__info14_1",
    BUL_INFO_SB_V1__info14_2 = "BUL_INFO_SB_V1__info14_2",
    BUL_INFO_SB_V1__info14_3 = "BUL_INFO_SB_V1__info14_3",
    BUL_INFO_SB_V1__info14_4 = "BUL_INFO_SB_V1__info14_4",
    BUL_INFO_SB_V1__info14_5 = "BUL_INFO_SB_V1__info14_5",

    BUL_INFO_SB_V1__info15_1 = "BUL_INFO_SB_V1__info15_1",
    BUL_INFO_SB_V1__info15_2 = "BUL_INFO_SB_V1__info15_2",
    BUL_INFO_SB_V1__info15_3 = "BUL_INFO_SB_V1__info15_3",
    BUL_INFO_SB_V1__info15_4 = "BUL_INFO_SB_V1__info15_4",

    BUL_INFO_SB_V1__info16_1 = "BUL_INFO_SB_V1__info16_1",
    BUL_INFO_SB_V1__info16_2 = "BUL_INFO_SB_V1__info16_2",
    BUL_INFO_SB_V1__info16_3 = "BUL_INFO_SB_V1__info16_3",
    BUL_INFO_SB_V1__info16_4 = "BUL_INFO_SB_V1__info16_4",
    BUL_INFO_SB_V1__info16_5 = "BUL_INFO_SB_V1__info16_5",
    BUL_INFO_SB_V1__info16_6 = "BUL_INFO_SB_V1__info16_6",
    BUL_INFO_SB_V1__info16_7 = "BUL_INFO_SB_V1__info16_7",

    BUL_INFO_SB_V1__info17_1 = "BUL_INFO_SB_V1__info17_1",
    BUL_INFO_SB_V1__info17_2 = "BUL_INFO_SB_V1__info17_2",
    BUL_INFO_SB_V1__info17_3 = "BUL_INFO_SB_V1__info17_3",
    BUL_INFO_SB_V1__info17_4 = "BUL_INFO_SB_V1__info17_4",
    BUL_INFO_SB_V1__info17_5 = "BUL_INFO_SB_V1__info17_5",
    BUL_INFO_SB_V1__info17_6 = "BUL_INFO_SB_V1__info17_6",
    BUL_INFO_SB_V1__info17_7 = "BUL_INFO_SB_V1__info17_7",
    BUL_INFO_SB_V1__info17_8 = "BUL_INFO_SB_V1__info17_8",
    BUL_INFO_SB_V1__info17_9 = "BUL_INFO_SB_V1__info17_9",
    BUL_INFO_SB_V1__info17_10 = "BUL_INFO_SB_V1__info17_10",
    BUL_INFO_SB_V1__info17_10extra = "BUL_INFO_SB_V1__info17_10extra",

    BUL_INFO_SB_V1__info18_1 = "BUL_INFO_SB_V1__info18_1",
    BUL_INFO_SB_V1__info18_1extra = "BUL_INFO_SB_V1__info18_1extra",

    BUL_INFO_SB_V1__info19_1 = "BUL_INFO_SB_V1__info19_1",
    BUL_INFO_SB_V1__info19_2 = "BUL_INFO_SB_V1__info19_2",
    BUL_INFO_SB_V1__info19_3 = "BUL_INFO_SB_V1__info19_3",

    BUL_INFO_SB_V1__info20_1 = "BUL_INFO_SB_V1__info20_1",
    BUL_INFO_SB_V1__info20_2 = "BUL_INFO_SB_V1__info20_2",
    BUL_INFO_SB_V1__info20_3 = "BUL_INFO_SB_V1__info20_3",
    BUL_INFO_SB_V1__info20_4 = "BUL_INFO_SB_V1__info20_4",
    BUL_INFO_SB_V1__info20_5 = "BUL_INFO_SB_V1__info20_5",

    BUL_INFO_SB_V1__info21_1 = "BUL_INFO_SB_V1__info21_1",
    BUL_INFO_SB_V1__info21_2 = "BUL_INFO_SB_V1__info21_2",
    BUL_INFO_SB_V1__info21_3 = "BUL_INFO_SB_V1__info21_3",
    BUL_INFO_SB_V1__info21_4 = "BUL_INFO_SB_V1__info21_4",
    BUL_INFO_SB_V1__info21_4extra = "BUL_INFO_SB_V1__info21_4extra",

    BUL_INFO_SB_V1__info22_1 = "BUL_INFO_SB_V1__info22_1",
    BUL_INFO_SB_V1__info22_2 = "BUL_INFO_SB_V1__info22_2",
    BUL_INFO_SB_V1__info22_3 = "BUL_INFO_SB_V1__info22_3",
    BUL_INFO_SB_V1__info22_4 = "BUL_INFO_SB_V1__info22_4",
    BUL_INFO_SB_V1__info22_5 = "BUL_INFO_SB_V1__info22_5",

    BUL_INFO_SB_V1__info23_1 = "BUL_INFO_SB_V1__info23_1",
    BUL_INFO_SB_V1__info23_1extra = "BUL_INFO_SB_V1__info23_1extra",

    BUL_INFO_SB_V1__info24_1 = "BUL_INFO_SB_V1__info24_1",

    BUL_INFO_SB_V1__info25_1 = "BUL_INFO_SB_V1__info25_1",

    BUL_INFO_SB_V1__info26_1 = "BUL_INFO_SB_V1__info26_1",
    BUL_INFO_SB_V1__info26_1extra = "BUL_INFO_SB_V1__info26_1extra",

}
